export const toolType = {
    "SAW": "Пила",
    "MILLING_CUTTER": "Фреза",
    "ANY": "Любой",
}
